import React, { useState, useEffect, useRef } from 'react';
import { Bell, LogOut, Menu, AlertCircle, Clock } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { apiFetch } from '../utils/apiClient';
import { formatDateDDMMYYYY } from '../utils/formatDate';
import './Layout.css';

const Topbar = ({ onMenuClick }) => {
  const navigate = useNavigate();
  const [alerts, setAlerts] = useState({ overdue: [], dueSoon: [] });
  const [notifOpen, setNotifOpen] = useState(false);
  const notifRef = useRef(null);

  const fetchAlerts = async () => {
    try {
      const response = await apiFetch('/api/employees/salary-alerts');
      if (response.ok) {
        const data = await response.json();
        setAlerts(data);
      }
    } catch (e) {
      console.error('Error fetching salary alerts');
    }
  };

  useEffect(() => {
    fetchAlerts();
    const interval = setInterval(fetchAlerts, 60000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (notifRef.current && !notifRef.current.contains(e.target)) {
        setNotifOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/login');
  };

  const toggleNotif = () => {
    if (!notifOpen) fetchAlerts();
    setNotifOpen(open => !open);
  };

  const goToSalary = () => {
    setNotifOpen(false);
    navigate('/salary');
  };

  const totalAlerts = alerts.overdue.length + alerts.dueSoon.length;

  return (
    <header className="topbar">
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <button className="icon-btn mobile-menu-btn" onClick={onMenuClick} title="Menu">
          <Menu size={22} />
        </button>
        <div className="topbar-search">
          {/* Placeholder for future search */}
        </div>
      </div>
      <div className="topbar-actions">
        <div className="notif-wrapper" ref={notifRef}>
          <button className="icon-btn" onClick={toggleNotif} title="Notifications">
            <Bell size={20} />
            {totalAlerts > 0 && <span className="badge">{totalAlerts > 9 ? '9+' : totalAlerts}</span>}
          </button>

          {notifOpen && (
            <div className="notif-dropdown">
              <div className="notif-dropdown-header">Salary Notifications</div>
              <div className="notif-list">
                {totalAlerts === 0 ? (
                  <div className="notif-empty">You're all caught up — no salaries due soon.</div>
                ) : (
                  <>
                    {alerts.overdue.map(item => (
                      <div key={`overdue-${item.employeeId}`} className="notif-item overdue" onClick={goToSalary}>
                        <AlertCircle size={16} style={{ flexShrink: 0, marginTop: '2px' }} />
                        <span>
                          <strong>{item.name}</strong> — salary overdue by {item.daysOverdue} day{item.daysOverdue === 1 ? '' : 's'}
                          {' '}(was due {formatDateDDMMYYYY(item.nextPayingDate)}, Rs{item.baseSalary})
                        </span>
                      </div>
                    ))}
                    {alerts.dueSoon.map(item => (
                      <div key={`due-${item.employeeId}`} className="notif-item due-soon" onClick={goToSalary}>
                        <Clock size={16} style={{ flexShrink: 0, marginTop: '2px' }} />
                        <span>
                          <strong>{item.name}</strong> — salary {item.daysUntilDue === 0 ? 'due today' : `due in ${item.daysUntilDue} day${item.daysUntilDue === 1 ? '' : 's'}`}
                          {' '}({formatDateDDMMYYYY(item.nextPayingDate)}, Rs{item.baseSalary})
                        </span>
                      </div>
                    ))}
                  </>
                )}
              </div>
            </div>
          )}
        </div>
        <div className="user-profile">
          <div className="avatar">A</div>
          <span>Admin</span>
        </div>
        <button className="icon-btn logout-btn" onClick={handleLogout} title="Logout">
          <LogOut size={20} />
        </button>
      </div>
    </header>
  );
};

export default Topbar;
